import { Component } from "react";
import { FormattedMessage } from "react-intl";

import type { ConnectionWithTotalCount } from "../utils/relay";

const renderIndividualDefault = ({ account }: { account: string }): JSX.Element => (
  <span className="contributorsText-account">{account}</span>
);

const renderOtherDefault = ({ count }: { count: number }): JSX.Element => (
  <span className="contributorsText-account">{count}</span>
);

interface Props {
  intl: any;
  contributors: ConnectionWithTotalCount<{
    account: string;
  }>;
  renderIndividual?: typeof renderIndividualDefault;
  renderOther?: typeof renderOtherDefault;
}

export class ContributorsTextLabel extends Component<Props> {
  renderText() {
    const { contributors } = this.props;

    const renderIndividual = this.props.renderIndividual || renderIndividualDefault;
    const renderOther = this.props.renderOther || renderOtherDefault;

    if (contributors.totalCount == null) {
      throw new Error("No totalCount in contributors");
    }
    switch (contributors.totalCount) {
      case 0:
        return null; // XXX: it is a bug, but it ignores the error here.
      case 1:
        return renderIndividual({ account: contributors.edges[0].node.account });
      case 2:
        return (
          <FormattedMessage
            id="ContributorsLabel.forTwoContributors"
            values={{
              contributor1: renderIndividual({ account: contributors.edges[0].node.account }),
              contributor2: renderIndividual({ account: contributors.edges[1].node.account }),
            }}
          />
        );
      default:
        return (
          <FormattedMessage
            id="ContributorsLabel.forOverThreeAuthor"
            values={{
              contributor1: renderIndividual({ account: contributors.edges[0].node.account }),
              contributor2: renderIndividual({ account: contributors.edges[1].node.account }),
              otherContributorCount: renderOther({ count: contributors.totalCount - 2 }),
            }}
          />
        );
    }
  }

  render() {
    return <div className="contributorsText">{this.renderText()}</div>;
  }
}
